import { useState, useEffect, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import OrganizationsFilters from './components/OrganizationsFilters'
import OrganizationDashboard from './components/OrganizationDashboard'

const OrganizationsPage = () => {
  const [searchParams] = useSearchParams()
  const [filters, setFilters] = useState<{
    year?: number
    cpvCode: string
    organizationName: string
  }>(() => {
    const yearParam = searchParams.get('year')
    return {
      year: yearParam ? parseInt(yearParam) : undefined,
      cpvCode: searchParams.get('cpv_code') || '',
      organizationName: searchParams.get('organization_name') || '',
    }
  })

  const handleFiltersChange = useCallback(
    (newFilters: { year?: number; cpvCode: string; organizationName: string }) => {
      setFilters(newFilters)
    },
    [],
  )

  const handleOrganizationClick = (organizationName: string) => {
    // Navigate to drilldown page with organization name encoded in URL
    window.location.href = `/organizations/${encodeURIComponent(organizationName)}${searchParams.toString() ? '?' + searchParams.toString() : ''}`
  }

  const handleRefresh = () => {
    // Trigger refresh of statistics
    window.location.reload()
  }

  return (
    <div className="space-y-6">
      <div className="bg-surface-raised rounded-lg border border-border-subtle p-6">
        <h1 className="text-2xl font-bold text-ink mb-2">Organizacje</h1>
        <p className="text-ink-secondary">
          Analiza zamawiających publicznych - ranking organizacji wg wartości i liczby kontraktów
        </p>
      </div>

      <OrganizationsFilters onFiltersChange={handleFiltersChange} />

      <OrganizationDashboard
        year={filters.year}
        cpvCode={filters.cpvCode}
        organizationName={filters.organizationName}
        onOrganizationClick={handleOrganizationClick}
        onRefresh={handleRefresh}
      />
    </div>
  )
}

export default OrganizationsPage
